<router-outlet></router-outlet>
<sidkik-tracker [linkedInInsightsId]="linkedInInsightsId" [activeCampaignId]="activeCampaignId" [fbPixelId]="fbPixelId"
  [clarityId]="clarityId"></sidkik-tracker>